/**
 * El aviso central, con la política de Recuperos.
 *
 * ── Por qué no se usa `MPFNToaster` del design system ──────────────────────
 *
 * Porque no acepta ninguna prop y tiene tres decisiones cableadas que aquí son
 * incorrectas:
 *
 *  · **`theme: 'system'`** — el aviso sigue la preferencia del sistema
 *    operativo mientras la aplicación está fijada en claro (`UI-14`). En un
 *    equipo con el tema oscuro puesto, los avisos salen oscuros sobre una
 *    interfaz clara. **Es la causa de que los colores parezcan cambiar según
 *    lo que responda la página**, que no cambiaban por el tipo de mensaje.
 *  · **`duration: 5000` para todo** — un error necesita más tiempo que un
 *    éxito. Recuperos fija éxito 5–6 s y **error ≥ 8 s**, porque un error se
 *    lee, se entiende y a veces se copia.
 *  · **`position: 'top-right'`** — tapa la acción primaria de la cabecera de
 *    página, que es justo donde acaba de pulsar el usuario.
 *
 * Y su API `notify` acepta **un solo string**: sin descripción, sin acción y
 * sin identificador para deduplicar.
 *
 * ── Lo que SÍ se conserva del design system ────────────────────────────────
 *
 * La librería es la misma —`sonner`, fijada a la versión exacta que usa el DS
 * para que no convivan dos copias— y **el estilo también**: la clase
 * `mpfn-toaster` es la que el DS estiliza en su `sonner.css`. Esto no
 * reimplementa el aviso del DS: usa la pieza que el DS eligió, con la
 * configuración que el DS no dejó configurar.
 *
 * Cuando el design system exponga estas props, este archivo se borra y se
 * vuelve a `MPFNToaster`. Está escrito para que eso sea trivial.
 */
import { Toaster } from 'sonner'

/** `UI-11` con los tiempos de Recuperos §10. */
export const DURACION = {
  exito: 5_000,
  info: 6_000,
  aviso: 7_000,
  /** Un error se lee, se entiende y a veces se copia: necesita más tiempo. */
  error: 9_000,
} as const

export function Avisos() {
  return (
    <Toaster
      className="mpfn-toaster"
      // Abajo a la derecha: arriba taparía la acción de la cabecera de página,
      // que es donde el usuario acaba de pulsar.
      position="bottom-right"
      // Fijo en claro mientras el tema oscuro no esté validado (`UI-14`).
      // Con `system` el aviso se desacopla de la aplicación.
      theme="light"
      closeButton
      richColors={false}
      // Tres a la vista. Con más, los de abajo quedan fuera de pantalla y el
      // usuario no llega a leerlos.
      visibleToasts={3}
      duration={DURACION.exito}
      toastOptions={{ className: 'sigfisc-aviso' }}
    />
  )
}
